import React from "react";

// Página PÚBLICA de retorno tras pago exitoso.
// No consultamos datos personales aquí (no exponemos PII); la confirmación
// formal la escribe el webhook y llega por correo.

function ReservaExito() {
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get("session_id");

  return (
    <div style={{ minHeight: "100vh", background: "#f1f5f9", display: "flex",
      alignItems: "center", justifyContent: "center", padding: "24px 12px" }}>
      <div style={{ maxWidth: 460, width: "100%", background: "#fff", borderRadius: 16,
        boxShadow: "0 4px 24px rgba(0,0,0,0.08)", padding: "36px 28px", textAlign: "center" }}>
        <div style={{ width: 68, height: 68, borderRadius: "50%", background: "#dcfce7",
          display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px" }}>
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.2"
            strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
        </div>
        <h2 style={{ margin: 0, fontSize: "1.35rem", fontWeight: 800, color: "#0f172a" }}>¡Pago recibido!</h2>
        <p style={{ margin: "10px 0 0", color: "#475569", fontSize: "0.9rem", lineHeight: 1.5 }}>
          Tu reserva quedó confirmada. Te enviaremos un correo con el detalle de tus lugares.
        </p>
        <p style={{ margin: "8px 0 0", color: "#94a3b8", fontSize: "0.75rem" }}>
          Si no lo ves, revisa tu carpeta de spam.
        </p>
        {sessionId && (
          <p style={{ margin: "18px 0 0", color: "#cbd5e1", fontSize: "0.68rem", wordBreak: "break-all" }}>
            Ref: {sessionId}
          </p>
        )}
        <a href="/lugares-fiestas" style={{ display: "inline-block", marginTop: 22, color: "#0ea5e9",
          fontSize: "0.82rem", textDecoration: "none", fontWeight: 600 }}>
          ← Volver
        </a>
      </div>
    </div>
  );
}

export default ReservaExito;
